import { motion, useScroll, useTransform } from "motion/react";
import { useRef } from "react";

export function Section({ children, className = "", id }) {
  const ref = useRef(null);
  // const { scrollYProgress } = useScroll({
  //   target: ref,
  //   offset: ["start end", "end start"],
  // });

  // const y = useTransform(scrollYProgress, [0, 1], [100, -100]);
  // const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);

  return (
    <motion.section
      ref={ref}
      id={id}
      // style={{ y, opacity }}
      className={`relative py-8 md:py-12 lg:py-16 ${className}`}
    >
      {children}
    </motion.section>
  );
}
